export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/book-occurrence/resources/components.js